import React from 'react';
import PropTypes from 'prop-types';
import WorkOrderNotification from 'workOrderComponents/WorkOrderNotification';
import {FormattedDate} from 'react-intl';
const RepeatDisplay = (props) => {

    const {repeatStatus, isLoading} = props;

    if (!repeatStatus) {
        return null;
    }


    const dateDisplay = repeatStatus.get('jobDate') ? (
                        <FormattedDate
                        value={repeatStatus.get('jobDate')}
                        year="2-digit"
                        month="2-digit"
                        day="2-digit"/>
    ) : null;

    return (
        <WorkOrderNotification
            isLoading={isLoading}
            loadingMessage="Checking for repeat..."
            hasData={repeatStatus.get('isRepeat') === '1'}
            style={{
            paddingTop: '5px',
            width: '100%'
        }}
            icon="warning"
            iconColor="red-text text-darken-2">

            <div style={{
                width: '100%'
            }}>
                <h6 className="red-text text-darken-2">Repeat</h6>
                <div
                    className="left"
                    style={{
                    width: '45%'
                }}>
                    <label
                        style={{
                        paddingRight: '2px'
                    }}>Order #:</label>
                    {repeatStatus.get('workOrderNO')}<br/>
                    <label
                        style={{
                        paddingRight: '2px'
                    }}>Tech Id:</label>
                    {repeatStatus.get('actualTechnicianID')}
                </div>

                <div
                    className="right"
                    style={{
                    width: '55%',
                    paddingLeft: '5px',
                    paddingRight: '5px'
                }}>
            
                    {repeatStatus.get('primarysolutioncode')}<br/>
                    <label
                        style={{
                        paddingRight: '2px'
                    }}>Date:</label>
                    
                    {dateDisplay}
                </div>

            </div>

        </WorkOrderNotification>
    );

};

RepeatDisplay.propTypes = {
    isLoading: PropTypes.bool,
    repeatStatus: PropTypes.object
};

export default RepeatDisplay;



// WEBPACK FOOTER //
// ./src/components/work-order/RepeatDisplay.js